var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage-Tags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sell_24dp_5F6368_FILL1_wght400_GRAD0_opsz24",
    transform: "translate(2, 2)",
    fill: "#98A6D6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.825,20.825 L0,10 L0,0 L10,0 L20.8,10.85 L10.825,20.825 Z M4.5,6 C4.91666667,6 5.27083333,5.85416667 5.5625,5.5625 C5.85416667,5.27083333 6,4.91666667 6,4.5 C6,4.08333333 5.85416667,3.72916667 5.5625,3.4375 C5.27083333,3.14583333 4.91666667,3 4.5,3 C4.08333333,3 3.72916667,3.14583333 3.4375,3.4375 C3.14583333,3.72916667 3,4.08333333 3,4.5 C3,4.91666667 3.14583333,5.27083333 3.4375,5.5625 C3.72916667,5.85416667 4.08333333,6 4.5,6 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.24310777,4.5 C5.72681704,4.5 4.5,5.7375 4.5,7.25 C4.5,8.7625 5.72681704,10 7.24310777,10 C8.7593985,10 10,8.7625 10,7.25 C10,5.7375 8.7593985,4.5 7.24310777,4.5 Z",
    id: "Path",
    fill: "#4C69BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/Tags.76d6d2be.svg";
export { ForwardRef as ReactComponent };